import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import {
    TextField,
    Button,
    Grid
} from '@material-ui/core'
import DropZoneMultiple from './../components/DropZoneMultiple'
import {
    CustomSnackBar,
    BaseEditor
} from './../components'
import axios from './../plugins/axios'

const styles = theme => ({
    marginBottom: {
        margin: '0 0 20px 0'
    }
})
class PostForm extends Component {

    static defaultProps = {
        title: '',
        images: [],
        body: '',
        enTitle: '',
        enBody: '',
    }

    constructor(props) {
        super(props)

        const {
            title,
            images,
            body,
            enTitle,
            enBody,
        } = props

        this.state = {
            fetching: false,
            disabled: false,
            isSnackOpen: false,
            errors: {},
            title,
            images,
            body,
            enTitle,
            enBody,
        }
    }

    handleChange = name => e => {
        this.setState({
            [name]: e.target.value
        })
    }

    reset = () => {
        this.setState({
            errors: {},
            title: '',
            images: [],
            body: '',
            enTitle: '',
            enBody: '',
        })
    }

    storeOrUpdate = async e => {
        e.preventDefault()
        this.setState({
            disabled: true,
            errors: {}
        })

        const {
            path,
            method
        } = this.props

        const {
            title,
            images,
            body,
            enTitle,
            enBody
        } = this.state

        try {
            await axios[method](path, {
                title,
                images,
                body,
                enTitle,
                enBody
            })

            this.setState({
                isSnackOpen: true
            })

            if (method === 'post') {
                this.reset()
            }

            this.setState({
                disabled: false
            })
        } catch (err) {
            if (err.response.status === 422) {
                const { errors } = err.response.data
                this.setState({ errors })
            }
        }
    }

    snackClose = () => {
        this.setState({
            isSnackOpen: false
        })
    }

    editorChange = name => e => {
        this.setState({
            [name]: e.target.getContent()
        })
    }

    onChange = (path, bool) => {
        let copyImages = []
        if (bool === undefined) {
            this.setState(prevState => ({
                images: [...prevState.images, path]
            }))
        } else {
            copyImages = this.state.images.filter(val =>
                val !== path
            )
            this.setState({
                images: copyImages
            })
        }
        console.log(path, bool)
    }

    render() {
        const {
            title,
            images,
            body,
            enTitle,
            enBody,
            isSnackOpen,
            errors
        } = this.state

        const { marginBottom } = this.props.classes

        const { message } = this.props
        return (
            <div>

                <form
                    onSubmit={this.storeOrUpdate}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField
                                error={!!errors.title}
                                helperText={errors.title}
                                label="Гарчиг"
                                value={title}
                                onChange={this.handleChange('title')}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                            />
                            <div className={marginBottom}>
                                <DropZoneMultiple
                                    uploadPath="image/upload"
                                    onChange={this.onChange}
                                    files={images}
                                />
                            </div>
                            <div className={marginBottom}>
                                <BaseEditor
                                    value={body}
                                    onChange={this.editorChange('body')}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                error={!!errors.enTitle}
                                helperText={errors.enTitle}
                                label="Title"
                                value={enTitle}
                                onChange={this.handleChange('enTitle')}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                            />
                            <div className={marginBottom}>
                                <BaseEditor
                                    value={enBody}
                                    onChange={this.editorChange('enBody')}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                    >
                        Хадгалах
                    </Button>
                    <CustomSnackBar
                        message={message}
                        open={isSnackOpen}
                        snackClose={this.snackClose}
                    />
                </form>
            </div >
        )
    }
}

export default withStyles(styles)(PostForm)
